import { render, staticRenderFns } from "./promiseGoodsItemList.vue?vue&type=template&id=8fcb2398"
import script from "./promiseGoodsItemList.vue?vue&type=script&lang=js"
export * from "./promiseGoodsItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports